// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productAvailabilityStyles } from "@vanmeter/Overrides/Components/ProductAvailability";
import { fontConfig } from "@vanmeter/XDL/constants";
import { css } from "styled-components";

productAvailabilityStyles.availabilityByWarehouseModal = {
    sizeVariant: "medium",
};

productAvailabilityStyles.modalStatusWrapper = {
    css: css`
        display: flex;
        align-items: center;
        margin-bottom: 14px;
        > [class^="InventoryMessage"] {
            margin-left: 12px;
        }
    `,
};

productAvailabilityStyles.modalStatuslabelText = {
    ...fontConfig.smallSingleLine,
    css: css`
        &.warehouse-count {
            font-weight: ${fontConfig.weight.bold};
            margin-left: 4px;
        }
    `,
};

productAvailabilityStyles.availabilityByWarehouseTable = {
    cssOverrides: {
        wrapper: css`
            max-height: 408px;
        `,
    },
};

productAvailabilityStyles.availabilityByWarehouseTableCell = {
    css: css`
        width: 50%;
    `,
};

productAvailabilityStyles.container = {
    css: css`
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        gap: 8px;
    `,
};

productAvailabilityStyles.inventoryWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
    `,
};

productAvailabilityStyles.messageGridItem = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
    `,
};

productAvailabilityStyles.availabilityByWarehouseLinkGridItem = {
    css: css`
        align-items: center;
        display: flex;
    `,
};

productAvailabilityStyles.availabilityByWarehouseLink = {
    mergeCss: true,
    typographyProps: {
        ...fontConfig.xxSmallSingleLine,
        weight: fontConfig.weight.bold,
    },
};

productAvailabilityStyles.availLinkWrapper = {
    css: css`
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 8px;
    `,
};

productAvailabilityStyles.errorText = {
    ...fontConfig.xSmallSingleLine,
    weight: fontConfig.weight.bold,
};
